const StepTowardsSection = () => {
  return (
    <div
      className="section-full py-3 site-bg-dark twm-step-towards-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      {/* Background Image */}
      {/* <div
        className="twm-half-bg-pic"
        style={{
          backgroundImage: "url('/images/half-bg-pic.jpg')",
        }}
      ></div> */}

<div
  className="twm-half-bg-pic"
  style={{
    backgroundImage: `
      linear-gradient(to right, transparent, #2b2724),
      url('/images/half-bg-pic.jpg')
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
></div>

      <div className="container">

        {/* Section Title */}
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left text-white">
                Your Journey, Our Responsibility
              </div>

              <h2 className="twm-large-title site-text-white">
                Travel Comfortably With Garud Cab
              </h2>
            </div>
          </div>
        </div>

        {/* Section Content */}
        <div className="section-content">
          <div className="row twm-step-towards-section">

            {/* Affordable Fares */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img
                    src="/images/icons/label.png"
                    alt="Affordable Cab Fares"
                  />
                </div>

                <div className="twm-content">
                  <h3 className="twm-title">
                    Affordable &amp; Transparent Fares
                  </h3>

                  <p>
                    Enjoy competitive and transparent cab fares for Pune
                    city rides, outstation trips, airport transfers and
                    Pune to Mumbai travel with no unnecessary surprises.
                  </p>
                </div>
              </div>
            </div>

            {/* Professional Drivers */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img
                    src="/images/icons/customer-support.png"
                    alt="Professional Cab Drivers"
                  />
                </div>

                <div className="twm-content">
                  <h3 className="twm-title">
                    Experienced &amp; Professional Drivers
                  </h3>

                  <p>
                    Travel with confidence with experienced and
                    professional drivers who focus on safe, comfortable
                    and punctual journeys.
                  </p>
                </div>
              </div>
            </div>

            {/* 24/7 Service */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img
                    src="/images/icons/parking-area.png"
                    alt="24/7 Cab Booking"
                  />
                </div>

                <div className="twm-content">
                  <h3 className="twm-title">
                    24/7 Cab Booking &amp; Support
                  </h3>

                  <p>
                    Need a cab early in the morning or late at night?
                    Garud Cab Service is available for your travel needs
                    with convenient booking and customer support.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default StepTowardsSection;
